import { useState, useEffect } from 'react'
import { getLeveTypeV2API } from '../services/setting/leave'

function UseLeaveType({ excludeLeaveTypeId, isModalOpen = true } = {}) {
  const [type, setType] = useState([])
  useEffect(() => {
    const getLeaveType = async () => {
      const res = await getLeveTypeV2API({ excludeLeaveTypeId })
      if (!res || !res.result) return
      const newData = res.result.map((d, i) => {
        return {
          value: d.leaveTypeId,
          label: `${d.leaveTypeEn} `
        }
      })

      setType(newData)
    }
    if (isModalOpen) {
      getLeaveType()
    }
  }, [])
  return type
}

export default UseLeaveType
